import { api } from "../base";
import type { IUnrealizedPnlResponse } from "@pulse-ui/codegen-v2/generated_ts/risk_projection";

export type {
  IUnrealizedPnlResponse,
  IUnrealizedPnlRecord,
  IUnrealizedPnlAsset,
} from "@pulse-ui/codegen-v2/generated_ts/risk_projection";

const unrealizedPnlEndpoints = api.injectEndpoints({
  endpoints: (build) => ({
    getUnrealizedPnlMarks: build.query<IUnrealizedPnlResponse, string | void>({
      query: (account) => ({
        url: "/api/unrealized-pnl/v1/marks",
        params: account ? { account } : undefined,
      }),
    }),
  }),
});

export const {
  useGetUnrealizedPnlMarksQuery,
  useLazyGetUnrealizedPnlMarksQuery,
} = unrealizedPnlEndpoints;
